import throttle from 'lodash/throttle';
import { DirectiveOptions } from 'vue';

const watchOrientationOnResize = (el: HTMLElement): void => {
    const computed = window.getComputedStyle(el);
    const width = parseInt(computed.width || '', 10);
    const height = parseInt(computed.height || '', 10);

    if (width < (height * 1.5)) {
        el.classList.remove('is-vertically-oriented');
        el.classList.add('is-horizontally-oriented');
    } else {
        el.classList.remove('is-horizontally-oriented');
        el.classList.add('is-vertically-oriented');
    }
};

let callback: any = null;

const watchOrientation: DirectiveOptions = {
    bind: (el): void => {
        document.addEventListener('DOMContentLoaded', () => {
            callback = throttle(() => watchOrientationOnResize(el), 1000);
            watchOrientationOnResize(el);
            window.addEventListener('resize', callback, { passive: true });
        }, { passive: true });
    },
    unbind: (): void => {
        window.removeEventListener('resize', callback);
    },
};

export default watchOrientation;
